module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-ddec33902ab57481b82ed1598b768439.jpg";